import { render, staticRenderFns } from "./DepartmentListAddModal.vue?vue&type=template&id=3916a884&scoped=true&"
import script from "./DepartmentListAddModal.vue?vue&type=script&lang=js&"
export * from "./DepartmentListAddModal.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentListAddModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DepartmentListAddModal.vue?vue&type=style&index=1&id=3916a884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3916a884",
  null
  
)

export default component.exports